import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';
import './animations.css';
import { trackPageView } from './lib/analytics';
import Header from './components/Header';
import Hero from './components/Hero';
import UpcomingEvents from './components/UpcomingEvents';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import MeetTheTeam from './components/MeetTheTeam';
import Events from './components/Events';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminEditButton from './components/AdminEditButton';
import TeamLogin from './pages/TeamLogin';
import AdminDashboard from './pages/AdminDashboard';
import EmployeePortal from './pages/EmployeePortal';
import Careers from './pages/Careers';
import QuickAccess from './pages/QuickAccess';

const EVENTBRITE_URL = 'https://www.eventbrite.com/o/royal-bar-grill-120928056108';

// Main customer-facing homepage
const MainSite = () => (
  <>
    <Header />
    <Hero />
    <UpcomingEvents />
    <Menu />
    <Gallery />
    <Events />
    <Location />
    <Contact />
    <Footer />
    <AdminEditButton />
  </>
);

// Public reservations now go to Eventbrite. The old form/floor plan
// (Reservations.jsx, FloorPlan.jsx) are kept in the project for future use.
const ReservationsRedirect = () => {
  React.useEffect(() => {
    window.location.replace(EVENTBRITE_URL);
  }, []);
  return null;
};

// Careers page
const CareersPage = () => (
  <>
    <Header />
    <Careers />
    <Footer />
    <AdminEditButton />
  </>
);

// Meet the Team page (removed from homepage; still reachable via footer/direct URL)
const MeetTheTeamPage = () => (
  <>
    <Header />
    <MeetTheTeam />
    <Footer />
    <AdminEditButton />
  </>
);

// Fires a GA4 page_view on every SPA route change
const RouteTracker = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        offset="80px"
        richColors
        closeButton
        duration={2500}
        toastOptions={{ style: { fontSize: '15px' } }}
      />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/reservations" element={<ReservationsRedirect />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/quick-access" element={<QuickAccess />} />
          <Route path="/meet-the-team" element={<MeetTheTeamPage />} />
          <Route path="/team" element={<TeamLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/employee-portal" element={<EmployeePortal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;